import {inject, injectable} from "inversify";
import type {IApiResponse, IHttpClientService} from "data/services/http";
import type {AxiosResponse} from "axios";
import {Bindings} from "data/constants/bindings";
import {AbstractApiProvider} from "data/providers/api/abstract.api.provider";
import {ICoupon} from "./coupon.api.provider";

export interface IPrediction {
	tournament: number;
	squad: number;
	margin?: number;
	isCorrect?: null | boolean;
}

type TAnswersResponse = IApiResponse<{predictions: IPrediction[]}>;
type TSaveAnswersResponse = IApiResponse<{predictions: IPrediction[]; coupon?: ICoupon}>;

interface ISavePayload {
	predictions: IPrediction[];
	round: number;
}

export interface IPredictionApiProvider {
	answers: (roundId: number) => Promise<AxiosResponse<TAnswersResponse>>;
	save: (payload: ISavePayload) => Promise<AxiosResponse<TSaveAnswersResponse>>;
	autofill: (payload: ISavePayload) => Promise<AxiosResponse<TAnswersResponse>>;
}

@injectable()
export class PredictionApiProvider extends AbstractApiProvider implements IPredictionApiProvider {
	constructor(@inject(Bindings.ApiHTTPClient) private _http: IHttpClientService) {
		super();
	}

	answers = (roundId: number) =>
		this._http.get<TAnswersResponse>(`${this.language}/predictions/list`, {roundId});
	save = (payload: ISavePayload) =>
		this._http.post<TSaveAnswersResponse>(`${this.language}/predictions/save`, payload);
	autofill = (payload: ISavePayload) =>
		this._http.post<TAnswersResponse>(`${this.language}/predictions/autofill`, payload);
}
